var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Dot.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const Dot = ({
  color = '#EC868B',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "6",
  height: "6",
  viewBox: "0 0 6 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M3 6C1.344 6 0 4.656 0 3C0 1.344 1.344 -1.99477e-07 3 -1.99477e-07C4.656 -1.99477e-07 6 1.344 6 3C6 4.656 4.656 6 3 6Z",
    fill: color
  })
});